var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FileInputField } from './file-input-field/file-input-field';
import { ParagraphField } from './paragraph-field/paragraph-field';
import { AlertField } from './alert-field/alert-field';
import { Textfield } from './text-field/text-field';
import { SelectField } from './select-field/select-field';
import { RadioField } from './radio-field/radio-field';
import { TextareaField } from './text-area-field/text-area-field';
import { ThumbsField } from './rating-field/thumbs-field';
import { StarRatingField } from './rating-field/star-rating-field';
import { SubmitButtonField } from './submit-button-field/submit-button-field';
import { ConsentField } from './consent-field/consent-field';
import { CheckboxField } from './checkbox-field/checkbox-field';
import { Star1to5RatingField } from './rating-field/star1to5-rating-field';
import { isLanguageRtl } from '../../lib/is-rtl-language';
export var FieldSelector = function (_a) {
    var form = _a.form, values = _a.values, localizationFormatValues = _a.localizationFormatValues, files = _a.files, addFiles = _a.addFiles, removeFile = _a.removeFile, customFormField = _a.customFormField, inputValueChange = _a.inputValueChange, blurHandler = _a.blurHandler, buttonClickHandler = _a.buttonClickHandler, handleAlertLinkClick = _a.handleAlertLinkClick;
    var rtl = isLanguageRtl();
    return (_jsx(_Fragment, { children: form.reduce(function (acc, formField, index) {
            if (!formField.show) {
                return acc;
            }
            else {
                switch (formField.field_type) {
                    case 'paragraph':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(ParagraphField, { data: formField, localizationFormatValues: localizationFormatValues }, formField.qid),
                        ], false);
                    case 'alert':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(AlertField, { data: formField, localizationFormatValues: localizationFormatValues, handleAlertLinkClick: handleAlertLinkClick }, formField.qid),
                        ], false);
                    case 'textfield':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(Textfield, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange, blurHandler: blurHandler }, formField.qid),
                        ], false);
                    case 'select':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(SelectField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'radio':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(RadioField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'checkbox':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(CheckboxField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'textarea':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(TextareaField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange, blurHandler: blurHandler }, formField.qid),
                        ], false);
                    case 'thumbs':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(ThumbsField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange, rtl: rtl }, formField.qid),
                        ], false);
                    case 'stars':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(StarRatingField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'stars1to5':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(Star1to5RatingField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'submitButton':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(SubmitButtonField, { data: formField, buttonClickHandler: buttonClickHandler }, formField.qid),
                        ], false);
                    case 'consent':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(ConsentField, { data: formField, value: values[formField.qid], inputValueChange: inputValueChange }, formField.qid),
                        ], false);
                    case 'fileInput':
                        return __spreadArray(__spreadArray([], acc, true), [
                            _jsx(FileInputField, { data: formField, files: files[formField.qid], addFiles: addFiles, removeFile: removeFile, rtl: rtl }, formField.qid),
                        ], false);
                    default: {
                        var component = customFormField && customFormField(formField, index);
                        if (component) {
                            return __spreadArray(__spreadArray([], acc, true), [component], false);
                        }
                        return acc;
                    }
                }
            }
        }, []) }, void 0));
};
